import ScrollableContainer from '../util/ScrollableContainer'
import TypesOfWorkList from './TypesOfWorkList'
import {connect} from "../redux/utils";
import CategoryNode from "./CategoryNode";
import TypeOfWorkNode from "./TypeOfWorkNode";
import TemplateView from "../TemplateView";
import {getSortedTypeOfWorkList} from "./selectors";

class TypeOfWorkSelector extends TemplateView {
    constructor({
        onlyActive = true,
        onTypeSelected = () => {},
    }) {
        super()

        this.params = {
            onlyActive,
            onTypeSelected,
        }

        this.state = {
            typesOfWork: [],
            selectedTypeId: -1,
        }

        this.onAnyStatePropertyChanged(['typesOfWork','selectedTypeId'],() => this._renderList())
    }

    templateHtml() {
        return '<div class="components_typeOfWorkSelector"></div>'
    }

    afterRender() {
        this._renderList()
    }

    update() {
        super.update()
        if (this.scrollableContainer)
            this.scrollableContainer.forceUpdate()
    }

    _renderList() {
        this.$el.empty()

        this.scrollableContainer = new ScrollableContainer(
            null,
            new TypesOfWorkList({
                categoryRenderer: ($el, typeOfWork) => {
                    new CategoryNode(typeOfWork).init($el)
                },
                nodeRenderer: ($el, typeOfWork) => {
                    new TypeOfWorkNode({
                            typeOfWork,
                            selected: this.state.selectedTypeId === typeOfWork.id,
                            onClick: this.params.onTypeSelected
                        }
                    ).init($el)
                },
            })
        )
        this.scrollableContainer.init(this.$el).setState({
            typesOfWork: this._getTypesOfWork()
        })
    }

    _getTypesOfWork() {
        if (this.params.onlyActive) {
            return this.state.typesOfWork.filter(t => t.active || t.id === this.state.selectedTypeId)
        }

        return this.state.typesOfWork
    }
}

export default connect(
    state => ({
        typesOfWork: getSortedTypeOfWorkList(state)
    }),
)(TypeOfWorkSelector)


// WEBPACK FOOTER //
// ./web/js/typesOfWork/TypeOfWorkSelector.js